import { iconMap } from "./LeadButtons";

export enum LeadIconType {
  Viewers = "Viewers",
  Location = "Location",
  Call = "Call",
  Approve = "Approve",
  Reject = "Reject",
  Chat = "Chat",
}


const stringToEnumMap: Record<string, LeadIconType> = {
  faUsers: LeadIconType.Viewers,
  faMagnifyingGlassLocation: LeadIconType.Location,
  faPhone: LeadIconType.Call,
  faThumbsUp: LeadIconType.Approve,
  faThumbsDown: LeadIconType.Reject,
  faComment: LeadIconType.Chat,
  Viewers: LeadIconType.Viewers,
  Location: LeadIconType.Location,
  Call: LeadIconType.Call,
  Approve: LeadIconType.Approve,
  Reject: LeadIconType.Reject,
  Chat: LeadIconType.Chat,
};

export const getIconForType = (type: string): JSX.Element | null => {
  const iconType = stringToEnumMap[type];
  return iconType ? iconMap[iconType] : null;
};